// extracted by mini-css-extract-plugin
export default {"alert-title-orange":"Visit_alert-title-orange__UlJ5Z"};